import { Earth, Plus } from '@icon-park/react'
import { memo } from 'react'

import { useRouting } from '@/hooks'
import { Button, Flex } from '@/components'
import { ManualCard, Modal } from '@/components/derived'

import { useCompanyContext } from '../CompanyDetails.context'
import { getDescription } from '../utils'
import { ChannelsTable } from './Channels.table'
import { EditChannelModal } from './edit-modal/EditChannel.component'
import { AddChannelFormModal } from './components/add-channel-form-modal/AddChannelFormModal.component'

export const Channels = memo(Component)

function Component(): JSX.Element | null {
  const { companyID, changeQueryParam, queryParams } = useRouting()
  const { company, reloadCompany } = useCompanyContext()

  if (!companyID || !company) return null

  return (
    <>
      {company.motherID ?
        <ManualCard
          icon={Earth}
          healthCheck={company.healthCheck?.isChannelsChecked}
          title="Canais Monitorados"
          tooltip="Adicione as fontes de informação a serem monitoradas (sites, redes sociais). Preencha o nome, peso, tier, tipo e anexe os logotipos .SVG (40x40px e 203x50px)."
          description={getDescription(company.counts?.channels)}
        />
      : <ManualCard
          icon={Earth}
          healthCheck={company.healthCheck?.isChannelsChecked}
          title="Canais Monitorados"
          tooltip="Adicione as fontes de informação a serem monitoradas (sites, redes sociais). Preencha o nome, peso, tier, tipo e anexe os logotipos .SVG (40x40px e 203x50px)."
          description={getDescription(company.counts?.channels)}
          linkName="Editar"
          linkAction={() =>
            changeQueryParam({
              param: 'modal',
              value: 'canais',
              replaceAll: true,
            })
          }
        />
      }

      <Modal
        controlKey="canais"
        backToName={company.name}
        title="Canais Monitorados"
        subtitle={<span>Gerencie os canais monitorados desta empresa.</span>}
        icon={Earth}
        beforeClose={reloadCompany}>
        <Flex $type="column" $align="stretch" $gap={24} $fit>
          <Flex $type="row" $justify="flex-end" $fit>
            <Button.Root $variant="primary" onClick={() => changeQueryParam({ param: 'addChannel', value: 'true' })}>
              <Button.Icon value={Plus} />
              <Button.Text value="Adicionar Canal" />
            </Button.Root>
          </Flex>
          <ChannelsTable />
        </Flex>
      </Modal>

      {queryParams.addChannel && (
        <AddChannelFormModal onSuccess={() => changeQueryParam({ param: 'addChannel', value: undefined })} />
      )}
      <EditChannelModal />
    </>
  )
}
